module.exports = __webpack_public_path__ + "static/media/infoTooltip.d706cfdf.svg";